import axios from "axios";

const BASE = "/coffee/greencoffee";

export default {
  async getGreenCoffeeList(dataOptions) {
    const requestParams = {
      page: dataOptions.page,
      limit: dataOptions.itemsPerPage,
      search: dataOptions.search || undefined,
    };
    return axios
      .get(`${BASE}/list`, { params: requestParams })
      .then(({ data }) => data)
      .catch((err) => {
        if (err?.response?.status === 404 || err?.message?.includes("404")) {
          return { code: 200, data: { rows: [], count: 0 } };
        }
        return Promise.reject(err?.response || err);
      });
  },

  getGreenCoffeeOptions(recordId = null) {
    const params = recordId ? { recordId } : undefined;
    return axios
      .get(`${BASE}/options`, { params })
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response?.data || err));
  },

  /**
   * Outturns selectable as a DDS report's Out-turn No — only green coffee records with
   * at least one final lot that traces back to a farm.
   */
  getOutturnsForDds() {
    return axios
      .get(`${BASE}/outturns-for-dds`)
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response?.data || err));
  },

  checkOutturnNumber(outturnNumber, id = null) {
    const params = { outturnNumber };
    if (id) params.id = id;
    return axios
      .get(`${BASE}/check-outturn-number`, { params })
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response?.data || err));
  },

  getAdminGreenCoffeeById(id) {
    return axios
      .get(`${BASE}/${id}`)
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response?.data || err));
  },

  createAdminGreenCoffee(payload) {
    return axios
      .post(BASE, payload)
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response?.data || err));
  },

  // Update a pending green-coffee record; the backend marks it Completed.
  updateAdminGreenCoffee(id, payload) {
    return axios
      .put(`${BASE}/${id}`, payload)
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response?.data || err));
  },

  saveAdminCupping(payload) {
    return axios
      .post("/coffee/cupping/save", payload)
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response?.data || err));
  },

  getCuppingHistory(greenCoffeeId) {
    return axios
      .get("/coffee/cupping/list", { params: { greenCoffeeId } })
      .then(({ data }) => data)
      .catch((err) => Promise.reject(err?.response?.data || err));
  },
};
